import React from "react";

export function ErrorMessage({text}: ({ text: string })): React.ReactElement {

    return (
        <>
            <p>{text}</p>
        </>
    );
}

